export default function shouldDisplayLocation(context) {
  const { me, orgLocations, usersCanSeeSchedulesInOtherLocations, usersCanSeeOtherSchedules } =
    context;
  if (orgLocations.length <= 1) {
    return false;
  }

  const canSeeLocations = usersCanSeeOtherSchedules && usersCanSeeSchedulesInOtherLocations;
  return me.isManager || canSeeLocations || context.me.locations.length > 1;
}
